
(function(){
  var p = window.location.pathname || '';
  var isGameCollection = /\/collections\/(jatekok|tarsasjatek|strateg|csaladi-tarsasjatek|logikai|parti-tarsasjatek|puzzle|szerepjatek|gyerek-tarsasjatek)/i.test(p);
  if (!isGameCollection) return;

  function applyFixes(){
    document.querySelectorAll('button.collapsible-trigger, button.tag-list__header, .filter-group__title, .collection-sidebar__group h3, .collection-sidebar__group h4').forEach(function(el){
      var txt = (el.textContent || '').trim();
      if (/^Szerző$/i.test(txt) || /^SZERZŐ$/.test(txt)) {
        for (var i = 0; i < el.childNodes.length; i++){
          var n = el.childNodes[i];
          if (n.nodeType === 3 && /Szerző/i.test(n.nodeValue)) {
            n.nodeValue = n.nodeValue.replace(/Szerző/gi, 'Kiadó/Tervező');
          }
        }
      }
      if (/^Kötés$/i.test(txt) || /^KÖTÉS$/.test(txt)) {
        var group = el.closest('.collection-sidebar__group, .filter-group, .filter-block, [data-filter-block]');
        if (group) group.style.display = 'none';
      }
    });

    // Phase 19.34p — Kiadó duplikáció dedupe: ha "Kiadó" + "Kiadó/Tervező" mindkettő látszik,
    // rejtsd el a synthetic Booksy "Kiadó"-t (a Search & Discovery vendor "Kiadó/Tervező" elég).
    var kiadoFilters = [];
    var kiadoTervezo = null;
    document.querySelectorAll('button.collapsible-trigger, button.tag-list__header').forEach(function(el){
      var t = (el.textContent || '').trim();
      if (/^Kiadó$/i.test(t)) kiadoFilters.push(el);
      if (/Kiadó\/Tervező/i.test(t)) kiadoTervezo = el;
    });
    if (kiadoTervezo && kiadoFilters.length >= 1) {
      kiadoFilters.forEach(function(el){
        var group = el.closest('.collection-sidebar__group, .filter-group, .filter-block');
        if (group) group.style.display = 'none';
      });
    }
  }

  document.addEventListener('DOMContentLoaded', applyFixes);
  // S&D dinamikus re-render után újra
  var target = document.querySelector('.collection-sidebar, .collection__filters, aside') || document.body;
  if (window.MutationObserver && target) {
    new MutationObserver(function(){ applyFixes(); }).observe(target, { childList: true, subtree: true });
  }
})();
